"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.webRTCSupported = exports.videoCallsNotSupported = exports.isCallToday = exports.isCallJoinable = exports.isBookingJoinable = void 0;
var DetectRTC = _interopRequireWildcard(require("detectrtc"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _appointments = require("./appointments.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var webRTCSupported = function webRTCSupported() {
  return !!DetectRTC.isWebRTCSupported;
};

// We only want to provide a functioning "Join now" button when:
// - it is {buffer} minutes before call start, or
// - it is {buffer} minutes after call end
//
// Outside that timeframe, the button will not be shown at all
// on the dashboard
exports.webRTCSupported = webRTCSupported;
var isCallJoinable = function isCallJoinable(_ref) {
  var startsAt = _ref.startsAt,
    endsAt = _ref.endsAt,
    bufferBefore = _ref.bufferBefore,
    bufferAfter = _ref.bufferAfter;
  var now = (0, _momentTimezone.default)();
  return now.isBetween((0, _momentTimezone.default)(startsAt).subtract(bufferBefore, 'minutes'), (0, _momentTimezone.default)(endsAt).add(bufferAfter, 'minutes'));
};
exports.isCallJoinable = isCallJoinable;
var isBookingJoinable = function isBookingJoinable(_ref2) {
  var startsAt = _ref2.startsAt,
    duration = _ref2.duration;
  var endsAt = (0, _momentTimezone.default)(startsAt).add(duration, 'minutes');
  return isCallJoinable({
    startsAt: startsAt,
    endsAt: endsAt,
    bufferBefore: _appointments.JoinCallGracePeriodMinutes.before,
    bufferAfter: _appointments.JoinCallGracePeriodMinutes.after
  });
};
exports.isBookingJoinable = isBookingJoinable;
var isCallToday = function isCallToday(startsAt) {
  return (0, _momentTimezone.default)().isSame((0, _momentTimezone.default)(startsAt), 'day');
};
exports.isCallToday = isCallToday;
var videoCallsNotSupported = function videoCallsNotSupported() {
  return !webRTCSupported();
};
exports.videoCallsNotSupported = videoCallsNotSupported;